<div class="flex flex-column">
  <div class="col-12 p-0 align-items-center flex flex-column md:flex-row">
    <label class="col-12 md:col-3 py-0 px-0 m-0" for="residenceCode">{{screen.labels.residence}}</label>
    <div class="col-12 md:col-9 py-2 md:py-0 px-0 md:pl-2">
      <p-autoComplete name="residenceCode" [(ngModel)]="residenceHelp" [suggestions]="locations" [dropdown]="true"
        [forceSelection]="true" field="label" dataKey="value" inputStyleClass="uppercase"
        [placeholder]="screen.labels.residencePlaceholder" (completeMethod)="queryLocations($event.query)"
        (onSelect)="value.residence = $event.value.id" (ngModelChange)="verifyResidence()" class="no-margin"
        appendTo="body" validation>
      </p-autoComplete>
    </div>
  </div>

  <div class="col-12 px-0 pb-0 pt-3 align-items-center flex flex-column md:flex-row">
    <span class="col-12 md:col-3 py-0 px-0 m-0"></span>
    <div class="col-12 md:col-9 py-0 px-0 md:pl-2">
      <textarea pInputTextarea name="address" [(ngModel)]="value.address" [rows]="3" [autoResize]="false"
        [placeholder]="screen.labels.addressPlaceholder" class="uppercase no-margin" validation></textarea>
    </div>
  </div>
</div>